import React, { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';
import Avatar from '../Avatar';
import styles from './styles.module.css';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import Button from '../Button';
import Checkbox from '../CheckBox';
const ShareUsersContent = ({ submitFunction }) => {
  const {
    privateUsers,
    content,
    userChosenForShare,
    setUserChosenForShare,
    themeMode,
  } = useContext(AdminContext);
  console.log('chosen==', userChosenForShare);
  const clickFunction = (user) => {
    if (userChosenForShare?.uuid != user?.users?.[0]?.channelUser?.uuid) {
      setUserChosenForShare({
        id: user?.users?.[0]?.channelUser?.channelId,
        name: user?.users?.[0]?.channelUser?.channelName,
        imageName: user?.users?.[0]?.channelUser?.image?.name,
        uuid: user?.users?.[0]?.channelUser?.uuid,
      });
    } else {
      setUserChosenForShare({});
    }
  };
  return (
    <div className={`${styles.containerWrapper}`}>
      <div className={`${styles.header} borderBottom`}>
        {content?.shareUserHeader}
      </div>
      <div
        className={`${styles.container} ${themeMode == 'dark' && styles.dark}`}
      >
        {privateUsers
          ?.filter((x) => x.typeId != 2)
          ?.map((user, index) => (
            <div
              className={`flex flex-row justify-between items-center h-auto w-full my-[5px] cursor-pointer ${`userBoxStyle`} relative

              `}
              key={index}
              onClick={() => {
                clickFunction(user);
              }}
            >
              <div className={`flex flex-row justify-start items-start w-full`}>
                <Avatar
                  width={24}
                  height={24}
                  containerclassName={`cursorDefault`}
                  className={`cursorDefault`}
                  src={
                    user?.users?.[0]?.channelUser?.image?.name
                      ? user?.users?.[0]?.channelUser?.image?.name
                      : blanckUser
                  }
                  local={!user?.users?.[0]?.channelUser?.image?.name}
                />
                <p className={`text-right ${styles.userText}`}>
                  {user?.users?.[0]?.channelUser?.channelName
                    ? user?.users?.[0]?.channelUser?.channelName
                    : user?.users?.[0]?.channelUser?.username}
                </p>
              </div>
              <Checkbox
                className="mb-[22px]"
                checked={
                  user?.users?.[0]?.channelUser?.uuid ==
                  userChosenForShare?.uuid
                }
                // onChange={() => handleCheckbox(contact, index)}
                onClick={(e) => {
                  e.preventDefault();
                  clickFunction(user);
                }}
              />
            </div>
          ))}
      </div>
      <Button
        onClick={() => {
          if (Object.keys(userChosenForShare)?.length > 0) {
            submitFunction();
          }
        }}
        className={`sendBtn ${styles.button} flex flex-row justify-center items-center mx-auto`}
      >
        {content?.chatPage?.footer?.sendButton}
      </Button>
    </div>
  );
};
export default ShareUsersContent;
